import FieldSet from '../../FieldSet';

import { TeamStatusName } from './TeamStatusName';
import { TeamStatusPill } from './TeamStatusPill';

export class TeamStatusFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TeamStatusName, TeamStatusPill];
  }

  get title() {
    return 'Team status';
  }
}
